import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Authors',
  basePath: '/authors',
  columns: [
    { key: 'author_name', label: 'Name', sortable: true },
    { key: 'authortype_name', label: 'Author Type', sortable: true },
    { key: 'author_info', label: 'Info', sortable: true },
    { key: 'display_profile', label: 'Display Profile', sortable: true,
      render: (v) => v == 1 ? 'Yes' : 'No' },
    { key: 'author_position', label: 'Position', sortable: true },
    { key: 'author_email', label: 'Email', sortable: true },
  ],
  fields: [
    { key: 'author_name', label: 'Name', type: 'text', required: true },
    { key: 'authortype_id', label: 'Author Type', type: 'async-select',
      optionsUrl: '/author-types/options' },
    { key: 'author_info', label: 'Info', type: 'text' },
    { key: 'photo', label: 'Photo', type: 'file', accept: 'image/*', photo: true },
    { key: 'display_profile', label: 'Display profile', type: 'yesno', defaultValue: '0' },
    { key: 'author_position', label: 'Position', type: 'text' },
    { key: 'author_email', label: 'Email', type: 'text' },
    { key: 'twitter_link', label: 'Twitter link', type: 'text' },
    { key: 'linkedin_link', label: 'LinkedIn link', type: 'text' },
    { key: 'author_profile', label: 'Profile', type: 'rich-text' },
  ],
  defaultSort: { field: 'author_name', dir: 'asc' },
});
